<template>
  <div class="payments-table__wrapper">
    <transition name="fade">
      <SkeletonLoader
        v-if="isLoading"
        type="column-3"
        class="table-loader"
        :height="compressed ? '65px' : '85px'"
      />
      <div v-else class="payments-table">
        <div
          v-for="payment in calculatedPayments"
          :key="payment.plan_date"
          class="payments-table__column"
          :class="{
            'payments-table__column--zipped': calculatedPayments.length > 3,
          }"
        >
          <div class="payments-table__column_date">
            {{ $getFormattedDate(payment.plan_date, "MMMM") }}
          </div>
          <div class="payments-table__column_topay">
            {{ $currencyFormatter(payment.summa - payment.calculated ) }}
          </div>
          <div
            v-if="payment.calculated > 0"
            class="payments-table__column_paid"
          >
            {{ $currencyFormatter(payment.summa) }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SkeletonLoader from "@/components/shared/loaders/SkeletonLoader.vue";
import prepaymentCalculator from "@/composables/prepaymentCalculator";
import { onBeforeMount, ref, watch } from "vue";

export default {
  data(){
    return{
      calcResult: null
    }
  },
  props: {
    invoiceItems: {
      /**
       * @type {Array<import('@/api/bills').Prepayments>}
       */
      type: Array,
      required: true,
    },
    payingAmount: {
      type: Number,
      required: true,
    },
    compressed: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SkeletonLoader,
  },
  setup(props) {
    const isLoading = ref(true);
    const payments = ref([...props.invoiceItems]);
    const calculatedPayments = ref(null);
    function _updateTable(amount ) {
      payments.value = prepaymentCalculator(
        payments.value,
        amount)
        var result = [];
        calculatedPayments.value = payments.value.reduce(function(res, val) {
        let onlyDate = val.plan_date
        let order = val.order;
        if (!res[onlyDate]) {
          res[onlyDate] = { plan_date: onlyDate, summa: 0, calculated: 0, order: order};
          result.push(res[onlyDate])
        }
        res[onlyDate].summa += val.summa;
        res[onlyDate].calculated += val.calculated;
        return res;
        }, {});
      }

    onBeforeMount(async () => {     
      _updateTable(props.payingAmount);
      isLoading.value = false;
    });

    watch(
      () => props.payingAmount,
      (val) => {
        _updateTable(val);
      },
      {
        immediate: true,
      }
    );

    return {
      isLoading,
      payments,
      calculatedPayments
    };
  },
};
</script>

<style lang="scss" scoped>
.payments-table {
  font-family: "Roboto-Regular";
  background-color: #fff;
  display: flex;
  max-width: 100vw;
  padding: 7px 12px 0 12px;
  font-size: 17px;
  line-height: 20px;
  white-space: nowrap;
  overflow-x: auto;
  
  &__wrapper {
    position: relative;
    height: 85px;

    .table-loader {
      position: absolute;
      width: 100%;
    }
  }

  &__column {
    padding: 14px 25px 15px 25px;
    border: 1px solid #dbdbdb;
    border-radius: 10px;
    margin: 4px;
    width: 125px;
    max-width: 125px;

    &_date {
      color: #4A4A4A;
      padding-bottom: 7px;
      text-transform: capitalize;
    }

    &_topay {
      padding-bottom: 1px;
      color: #4a4a4a;
    }

    &_paid {
      color: #a8a8a8;
      text-decoration: line-through;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.btn {
  &__primary {
    margin-bottom: -15px;
  }
}
</style>